module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN300_1953398273.af6c8c65.png";